import { Injectable } from "@angular/core";
import {Observable} from "rxjs/Observable";
import {Speciality} from "./speciality.model";
import {environment} from "../../../app/config/environment";
import {MyHttp} from "../../../app/core/http";

@Injectable()
export class SpecialityService {

  constructor(private http: MyHttp) {}

  getSpecialities(): Observable<Speciality[]> {
    return this.http.get(environment.API + '/specialities')
      .map(res => res.json());
  }
}



// WEBPACK FOOTER //
// ./src/pages/shared/specialities/speciality.service.ts